// Магазин косметики (docs/spec/01, Монетизация): только внешний вид, никаких преимуществ в игре (без pay-to-win).
// За монеты (бесплатная валюта) или за Telegram Stars; монеты не покупаются за деньги и не выводятся.

export type ItemSlot = 'ball' | 'stadium' | 'frame' | 'celebration' | 'kit';
export const ITEM_SLOTS: readonly ItemSlot[] = ['ball', 'stadium', 'frame', 'celebration', 'kit'];

export interface ItemDto {
  id: string;
  slot: ItemSlot;
  name: string;
  /** цена в монетах; null — за монеты не продаётся */
  priceCoins: number | null;
  /** цена в Telegram Stars; null — за Stars не продаётся */
  priceStars: number | null;
  /** есть у всех с начала (предмет по умолчанию) */
  free?: boolean;
  /** цвета для отрисовки */
  colors: [string, string];
}

export const ITEMS: readonly ItemDto[] = [
  // Мяч — виден и сопернику, когда вы бьёте
  {
    id: 'ball-classic',
    slot: 'ball',
    name: 'Классика',
    priceCoins: null,
    priceStars: null,
    free: true,
    colors: ['#ffffff', '#222222'],
  },
  {
    id: 'ball-gold',
    slot: 'ball',
    name: 'Золотой',
    priceCoins: 300,
    priceStars: null,
    colors: ['#ffd23f', '#8a6d00'],
  },
  {
    id: 'ball-fire',
    slot: 'ball',
    name: 'Огненный',
    priceCoins: 500,
    priceStars: null,
    colors: ['#ff7a1a', '#c21f00'],
  },
  {
    id: 'ball-neon',
    slot: 'ball',
    name: 'Неон',
    priceCoins: null,
    priceStars: 15,
    colors: ['#5ef2ff', '#0a5b8a'],
  },
  // Стадион — фон ваших матчей
  {
    id: 'stadium-classic',
    slot: 'stadium',
    name: 'Вечерний',
    priceCoins: null,
    priceStars: null,
    free: true,
    colors: ['#145a31', '#061109'],
  },
  {
    id: 'stadium-sunset',
    slot: 'stadium',
    name: 'Закат',
    priceCoins: 400,
    priceStars: null,
    colors: ['#b4532a', '#1b0d1f'],
  },
  {
    id: 'stadium-snow',
    slot: 'stadium',
    name: 'Снежный',
    priceCoins: 600,
    priceStars: null,
    colors: ['#6f8fa8', '#0e1a26'],
  },
  {
    id: 'stadium-arena',
    slot: 'stadium',
    name: 'Арена',
    priceCoins: null,
    priceStars: 30,
    colors: ['#6a2bd1', '#0b0418'],
  },
  // Рамка аватара — видна сопернику и в лидерборде
  {
    id: 'frame-none',
    slot: 'frame',
    name: 'Без рамки',
    priceCoins: null,
    priceStars: null,
    free: true,
    colors: ['transparent', 'transparent'],
  },
  {
    id: 'frame-gold',
    slot: 'frame',
    name: 'Золотая',
    priceCoins: 500,
    priceStars: null,
    colors: ['#ffd23f', '#b8860b'],
  },
  {
    id: 'frame-diamond',
    slot: 'frame',
    name: 'Бриллиант',
    priceCoins: null,
    priceStars: 50,
    colors: ['#9ff3ff', '#5ec8ff'],
  },
  // Празднование вашего гола
  {
    id: 'celebration-confetti',
    slot: 'celebration',
    name: 'Конфетти',
    priceCoins: null,
    priceStars: null,
    free: true,
    colors: ['#ffd23f', '#3ddc84'],
  },
  {
    id: 'celebration-fireworks',
    slot: 'celebration',
    name: 'Салют',
    priceCoins: 400,
    priceStars: null,
    colors: ['#ff5a5f', '#ffd23f'],
  },
  {
    id: 'celebration-lightning',
    slot: 'celebration',
    name: 'Молния',
    priceCoins: null,
    priceStars: 20,
    colors: ['#fff6a0', '#5ec8ff'],
  },
  // Премиальные формы (обычные — бесплатно в профиле)
  {
    id: 'kit-royal',
    slot: 'kit',
    name: 'Королевская',
    priceCoins: 800,
    priceStars: null,
    colors: ['#4b2a8a', '#ffd23f'],
  },
  {
    id: 'kit-carbon',
    slot: 'kit',
    name: 'Карбон',
    priceCoins: null,
    priceStars: 40,
    colors: ['#2b2f36', '#ff5a5f'],
  },
];

export const itemById = (id: string | null | undefined) => ITEMS.find((i) => i.id === id);
/** Предмет по умолчанию в слоте (у всех с начала) */
export const defaultItem = (slot: Exclude<ItemSlot, 'kit'>) => ITEMS.find((i) => i.slot === slot && i.free)!;

export type EquippedDto = Record<Exclude<ItemSlot, 'kit'>, string>;

/** GET /api/shop */
export interface ShopDto {
  items: ItemDto[];
  /** купленные предметы (без бесплатных) */
  owned: string[];
  equipped: EquippedDto;
  coins: number;
  /** оплата Stars включена на этом сервере */
  starsEnabled: boolean;
}

/** POST /api/shop/stars-invoice — ссылка на счёт в Stars (Telegram.WebApp.openInvoice) */
export interface StarsInvoiceResponse {
  link: string;
}
